<template>
  <div id="func-52">
    <funcionalidade-header
      :titulo="tituloTela"
      :voltar="voltarNavegacao"
    >
    </funcionalidade-header>
    <GrupoFamiliar
      v-model="beneficiarioSelecionado"
      :style="beneficiarioSelecionado ? 'min-height: 600px' : ''"
      id-funcionalidade="52"
    >

      <div v-for="(item, i) in formatDadosPlano" :key="i">
        <div class="listagem-header">
          <span class="listagem-title">{{titulosCard[i]}}</span>
          <div v-if="beneficiarioSelecionado && isWidget">
            <AcoesPINSS :row="convertArrayInString(titulosCard[i], item)"/>
          </div>
        </div>
        <cardDropdown
          style="margin-top: 10px; margin-bottom: 20px"
          :entradaId="i + 1"
          :aberto="true"
          :tipo-despesa="false"
          :despesa="item">
        </cardDropdown>
      </div>
      <el-button @click="openDocument" :style="`background-color: ${estilo.aplicacao.corPrimariaAplicacao}1f`" class="card-options">
        <span :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}`" class="card-options-title">{{ tituloBotaoAnexo }}</span>
        <inline-svg :fill="estilo.aplicacao.corPrimariaAplicacao" class="arrow-card" :src="require('@/assets/icons/Arrow_chevron.svg')"></inline-svg>
      </el-button>
      <DialogoCarencias
        v-model="mostrarCarencias"
        :carencias="carencias"
        :top="'62vh'"
      />
      <el-button @click="goToContatos" class="card-options" :style="`background-color: ${estilo.aplicacao.corPrimariaAplicacao}1f`">
        <span :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}`" class="card-options-title">{{ tituloBotaoContatos }}</span>
        <inline-svg :fill="estilo.aplicacao.corPrimariaAplicacao" class="arrow-card" :src="require('@/assets/icons/Arrow_chevron.svg')"></inline-svg>
      </el-button>
    </GrupoFamiliar>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import GrupoFamiliar from '@/components/GrupoFamiliar/GrupoFamiliar'
import { mapGetters, mapState } from 'vuex'
import CardDropdown from '@/components/cards/CardDropdown'
import DialogoCarencias from '@/views/3/DialogoCarencias'
import InlineSvg from 'vue-inline-svg'
import moment from 'moment'
import AcoesPINSS from '@/views/52/AcoesPINSS.vue'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
export default {
  data () {
    return {
      beneficiarioSelecionado: null,
      dadosDoPlano: null,
      formatDadosPlano: [],
      titulosCard: [],
      urlDocumento: '',
      mostrarCarencias: false
    }
  },
  components: { CardDropdown, FuncionalidadeHeader, GrupoFamiliar, InlineSvg, DialogoCarencias, AcoesPINSS },
  computed: {
    ...mapState('SetupApp', ['apiAcesso']),
    ...mapGetters('SetupApp', ['configuracaoAcesso', 'estilo', 'canalAtendimentoOrigem', 'isWidget']),
    tituloTela () {
      return this.configuracaoAcesso.PINSS.parametros.textos.tituloTelaDetalhePINSS
    },
    tituloBotaoAnexo () {
      return this.configuracaoAcesso.PINSS.parametros.textos.labelBotaoExibeAnexo
    },
    tituloBotaoContatos () {
      return this.configuracaoAcesso.PINSS.parametros.textos.labelBotaoContatos
    },
    carencias () {
      if (!this.beneficiarioSelecionado || !this.beneficiarioSelecionado.beneficiarioDados) {
        return []
      }

      return this.beneficiarioSelecionado.beneficiarioDados.dadosDoPlano.carencias
    },
    voltarNavegacao () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return false
        default:
          return true
      }
    },
    payloadBeneficiarioPINSSDetalhe () {
      if (!this.beneficiarioSelecionado) {
        return {}
      }
      return {
        chaveUnica: this.beneficiarioSelecionado.chaveUnica,
        cor: this.beneficiarioSelecionado.cor,
        foto: this.beneficiarioSelecionado.foto,
        id: this.beneficiarioSelecionado.id,
        integracao: (this.beneficiarioSelecionado.beneficiarioDados || {}).integracao,
        matricula: this.beneficiarioSelecionado.matricula,
        nome: this.beneficiarioSelecionado.nome,
        numeroContrato: this.beneficiarioSelecionado.numeroContrato,
        tipoBeneficiario: this.beneficiarioSelecionado.tipoBeneficiario
      }
    }
  },
  watch: {
    beneficiarioSelecionado () {
      this.getDadosUsuario()
    }
  },
  methods: {
    openDocument () {
      window.open(this.urlDocumento, '__blank')
    },
    goToContatos () {
      this.$router.push('/8')
    },
    async getDadosUsuario () {
      const response = await this.apiAcesso.PINSS.detalhe({
        payload: {
          beneficiario: { ...this.payloadBeneficiarioPINSSDetalhe }
        }
      })

      if (!response.status) return
      this.urlDocumento = response.data.urlDocumentoTecnico
      this.dadosDoPlano = response.data.pinss
      this.formatObject()
    },
    convertArrayInString (titulo, arrayData) {
      let texto = ''
      texto += `${titulo}:\n`
      if (arrayData) {
        arrayData.forEach((grupo) => {
          texto += `${grupo.titulo}:   ${grupo.valor}\n`
        })
      }
      return { textoPuro: texto, titulo: titulo }
    },
    formatObject () {
      if (!this.dadosDoPlano) return
      this.dadosDoPlano.map(el => {
        const tituloValor = []
        this.titulosCard.push(el.titulo)
        if (!el.valores) return
        el.valores.map(el => {
          const expression = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
          const data = expression.test(el.valor)
          let value
          data ? value = moment(el.valor, 'YYYY-MM-DD').format('DD/MM/YYYY') : value = el.valor
          tituloValor.push({
            titulo: el.descricao,
            valor: value
          })
        })
        this.formatDadosPlano.push(tituloValor)
      })
    }
  },
  created () {
  }
}
</script>
<style lang="less">
#func-52 {
  .listagem-header {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .listagem-title {
    font-size: 16px;
    text-align: left;
    color: #333333;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .btn-carencias {
    padding: 0;
    text-transform: none;
    font-weight: 500;
    font-size: 14px;
    position: relative;
    bottom: 4px;
  }
  .card-carencias {
    position: relative;
    bottom: 25px;
    border-radius: 0 0 8px 8px;
    box-shadow: none;
    border: none;
    background-color: #F6F6F6;
  }
  .card-options {
    box-shadow: none;
    border: none;
    border-radius: 8px;
    padding: 25px 25px 25px 15px;
    width: 100%;
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
    text-transform: none;
    font-weight: 500;
    font-size: 14px;
  }
  .arrow-card {
    float: right;
  }
}
</style>
